import { ClipboardCheck, Search, FileText, Hammer } from "lucide-react";
import SectionFadeIn from "@/components/SectionFadeIn";
import { useTranslation } from 'react-i18next';

const icons = [ClipboardCheck, Search, FileText, Hammer];

const HowItWorks = () => {
  const { t } = useTranslation('home');

  const steps = (t('howItWorks.steps', { returnObjects: true }) as Array<{ step: string; label: string; title: string; desc: string }>).map((s, i) => ({
    ...s,
    icon: icons[i],
  }));

  return (
    <section className="section-padding">
      <div className="container-max">
        <SectionFadeIn>
          <div className="text-center mb-14">
            <div className="h-1 w-12 bg-brand-yellow mx-auto mb-4" />
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-3">{t('howItWorks.title')}</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">{t('howItWorks.subtitle')}</p>
          </div>
        </SectionFadeIn>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((s, i) => (
            <SectionFadeIn key={s.title} delay={i * 0.08}>
              <div className="relative text-center group">
                <div className="w-16 h-16 bg-foreground rounded-full flex items-center justify-center mx-auto mb-5 group-hover:bg-brand-yellow transition-colors duration-300">
                  <s.icon className="h-7 w-7 text-brand-yellow group-hover:text-foreground transition-colors duration-300" />
                </div>
                <div className="text-xs font-bold text-brand-yellow uppercase tracking-widest mb-2">{s.label}</div>
                <h3 className="text-lg font-bold text-foreground mb-2">{s.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                {i < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-[60%] w-[80%] border-t-2 border-dashed border-border" />
                )}
              </div>
            </SectionFadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
